<div class="fz-list-tournaments">
  <fz-widget-tournament-slider></fz-widget-tournament-slider>

  <!-- Filter section -->
  <section class="fz-list-tournaments__section_tags container">
    <div class="fz-list-tournaments__section_tags__root">
      <div class="fz-list-tournaments__section_tags__root__tag-list">
        <fz-refinement-list
          [items]="tags()"
          [selected]="selectedTags()"
          (selectionChanged)="tournamentTypeSelectionChange($event)"
        ></fz-refinement-list>
      </div>

      <a
        class="view-all-games"
        mat-button
        color="primary"
        (click)="gamesRoute()"
      >
        <span class="view-text">VIEW</span> ALL GAMES
        <mat-icon iconPositionEnd size="24">keyboard_arrow_right</mat-icon>
      </a>
    </div>
  </section>

  <section class="fz-list-tournaments__section_actions container">
    <div class="fz-list-tournaments__section_actions__root">
      <div class="fz-list-tournaments__section_actions__left">
        <h1 class="page-title">All Tournaments</h1>
        <fz-filters
          [activeFilterCount]="activeFilterCount()"
          (opened)="searchPanelOpened(true)"
          (closed)="searchPanelOpened(false)"
          (filterPanel)="toggleFilterPanelVisibility()"
        >
        </fz-filters>
        <fz-sort-by
          [criteria]="sortOptions()"
          initial="Featured"
          (sortChange)="onSortChange($event)"
        ></fz-sort-by>
      </div>

      <div class="fz-list-tournaments__section_actions__right">
        <fz-search
          placeholder="Search Tournaments..."
          [searchTerm]="search()"
          (searchChange)="onSearchChange($event)"
        ></fz-search>
        <fz-view-mode
          [initialMode]="viewMode()"
          (viewModeChange)="onViewModeChange($event)"
        ></fz-view-mode>
      </div>
    </div>
  </section>

  <!-- Mobile top bar -->
  <section class="container fz-list-tournaments__section_mobile">
    <div class="fz-flex justify-between align-center">
      <h1 class="page-title">All Tournaments</h1>
      <a
        class="view-all-games"
        mat-button
        color="primary"
        (click)="gamesRoute()"
      >
        ALL GAMES
        <mat-icon iconPositionEnd size="24">keyboard_arrow_right</mat-icon>
      </a>
    </div>
    <div class="fz-flex align-center gap-3">
      <fz-search
        appearance="icon"
        placeholder="Search Tournaments..."
        [searchTerm]="search()"
        (searchChange)="onSearchChange($event)"
        (expandChange)="toggleSearchExpanded($event)"
      ></fz-search>
      @if (!searchExpanded()) {
        <span class="flex-1"></span>
        <fz-sort-by
          appearance="icon"
          [criteria]="sortOptions()"
          initial="Featured"
          (sortChange)="onSortChange($event)"
        ></fz-sort-by>
      }
      <fz-filters
        [activeFilterCount]="activeFilterCount()"
        (opened)="searchPanelOpened(true)"
        (closed)="searchPanelOpened(false)"
        (filterPanel)="toggleFilterPanelVisibility()"
      >
      </fz-filters>

      @if (!searchExpanded()) {
        <fz-view-mode
          [initialMode]="viewMode()"
          (viewModeChange)="onViewModeChange($event)"
        ></fz-view-mode>
      }
    </div>
  </section>

  <section class="fz-list-tournaments__content container">
    @if (showFilters() && filterQuery.status() === 'success') {
      <aside>
        <div class="fz-list-tournaments__tournaments__filters">
          <fz-desktop-filters
            [facet]="facets()"
            [filters]="filters()"
            (filterChange)="updateFilterSelections($event)"
            (close)="closeFilterPanel()"
            (clear)="resetFilter()"
          >
          </fz-desktop-filters>
        </div>
      </aside>
    }
    <!-- Tournaments page -->
    <div class="fz-list-tournaments__content__main">
      @if (viewMode() === ViewMode.cards) {
        @switch (tournamentsQuery.status()) {
          @case ('pending') {
            <ng-container
              [ngTemplateOutlet]="loadingTournaments"
            ></ng-container>
          }
          @case ('error') {
            <div class="utility-message error">
              <img
                src="/shared/svg/error.svg"
                height="330"
                width="330"
                alt="Error illustration"
              />
              <div class="message">
                <p class="title mat-headline-medium">
                  Apologies for the inconvenience
                </p>
                <p class="">
                  We are currently experiencing difficulties with our service
                  providers. The App may not work as expected. We are working on
                  a resolution. Please try again in a few minutes.
                </p>
              </div>
            </div>
          }
          @case ('success') {
            <!-- Empty list -->
            @if (!hasTournaments()) {
              <fz-empty-list
                header="No results"
                loggedInMessage="We can't find any tournament matching your search criteria. Please reset your search criteria and try again."
                loggedOutMessage="We can't find any tournament matching your search criteria. Please reset your search criteria and try again."
                src="/shared/svg/no-search-results.svg"
                [isLoggedIn]="!!currentUser?.user?.uuid"
                [showLoginButton]="false"
                buttonText="Reset"
                (buttonEvent)="resetFilter()"
              ></fz-empty-list>
            }

            <!-- Cards View -->
            @if (viewMode() === ViewMode.cards) {
              <fz-tournaments-cards-view
                [tournaments]="tournamentsQuery.data()?.pages || []"
                (tournamentPressed)="onTournamentCardPress($event)"
                (share)="onTournamentShare($event)"
                (lastTournamentReached)="fetchMoreTournaments()"
              >
              </fz-tournaments-cards-view>
            }
          }
          @default {}
        }
      }

      <!-- Rows View -->
      @if (viewMode() === ViewMode.rows) {
        <!-- Show Empty List -->
        @if (
          prizeTournamentsQuery.data() &&
          prizeTournamentsQuery.data()?.items &&
          !prizeTournamentsQuery.data()?.items?.length &&
          cashTournamentsQuery.data() &&
          cashTournamentsQuery.data()?.items &&
          !cashTournamentsQuery.data()?.items?.length
        ) {
          <fz-empty-list
            header="No results"
            loggedInMessage="We can't find any tournament matching your search criteria. Please reset your search criteria and try again."
            loggedOutMessage="We can't find any tournament matching your search criteria. Please reset your search criteria and try again."
            src="/shared/svg/no-search-results.svg"
            [isLoggedIn]="!!currentUser?.user?.uuid"
            [showLoginButton]="false"
            buttonText="Reset"
            (buttonEvent)="resetFilter()"
          ></fz-empty-list>
        }

        @if (showPrizeTournaments()) {
          @switch (prizeTournamentsQuery.status()) {
            @case ('pending') {
              <fz-skeleton-table></fz-skeleton-table>
            }
            @case ('error') {}
            @case ('success') {
              @if (
                prizeTournamentsQuery.data() &&
                prizeTournamentsQuery.data()?.items &&
                prizeTournamentsQuery.data()?.items?.length
              ) {
                <div class="tournaments-table-view">
                  <h5 class="mat-headline-small mb--3">
                    Prize tournaments
                    <span class="tournaments-table-view__quantity"
                      >/
                      {{ prizeTournamentsQuery.data()?.total || 0 }}
                      tournaments</span
                    >
                  </h5>
                  <fz-tournaments-table-view
                    [tournaments]="prizeTournamentsQuery.data()?.items || []"
                    [total]="prizeTournamentsQuery.data()?.total || 0"
                    [showCategory]="true"
                    [isLoggedIn]="!!currentUser?.user?.uuid"
                    [tournamentType]="TournamentType.PRIZE"
                    [loading]="
                      prizeTournamentsQuery.status() === 'pending' || false
                    "
                    (tournamentPressed)="onTournamentCardPress($event)"
                    [currentUser]="currentUser"
                    (share)="onTournamentShare($event)"
                    (loadMoreTournaments)="
                      fetchPageTournaments($event, TournamentType.PRIZE)
                    "
                  >
                  </fz-tournaments-table-view>
                </div>
              }
            }
            @default {}
          }
        }

        @if (showCashTournaments()) {
          @switch (cashTournamentsQuery.status()) {
            @case ('pending') {
              <fz-skeleton-table></fz-skeleton-table>
            }
            @case ('error') {}
            @case ('success') {
              @if (
                cashTournamentsQuery.data() &&
                cashTournamentsQuery.data()?.items &&
                cashTournamentsQuery.data()?.items?.length
              ) {
                <div class="tournaments-table-view">
                  <h5 class="mat-headline-small mb--3">
                    Casual tournaments
                    <span class="tournaments-table-view__quantity"
                      >/
                      {{ cashTournamentsQuery.data()?.total || 0 }}
                      tournaments</span
                    >
                  </h5>
                  <fz-tournaments-table-view
                    [tournaments]="cashTournamentsQuery.data()?.items || []"
                    [total]="cashTournamentsQuery.data()?.total || 0"
                    [showCategory]="true"
                    [isLoggedIn]="!!currentUser?.user?.uuid"
                    [tournamentType]="TournamentType.CASUAL"
                    [loading]="
                      cashTournamentsQuery.status() === 'pending' || false
                    "
                    (tournamentPressed)="onTournamentCardPress($event)"
                    [passesLoaded]="true"
                    [currentUser]="currentUser"
                    (share)="onTournamentShare($event)"
                    (loadMoreTournaments)="
                      fetchPageTournaments($event, TournamentType.CASUAL)
                    "
                    [tournamentPassesForUser]="tournamentPassesForUser"
                  >
                  </fz-tournaments-table-view>
                </div>
              } @else {
                <fz-empty-list
                  header="No results"
                  loggedInMessage="We can't find any tournament matching your search criteria. Please reset your search criteria and try again."
                  loggedOutMessage="We can't find any tournament matching your search criteria. Please reset your search criteria and try again."
                  src="/shared/svg/no-search-results.svg"
                  [isLoggedIn]="!!currentUser?.user?.uuid"
                  [showLoginButton]="false"
                  buttonText="Reset"
                  (buttonEvent)="resetFilter()"
                ></fz-empty-list>
              }
            }
            @default {}
          }
        }
      }

      <!-- Promotion -->
      <section>
        <fz-widget-advertisements></fz-widget-advertisements>
      </section>

      <!-- stats -->
      <section>
        <fz-stat-box></fz-stat-box>
      </section>
    </div>
  </section>
</div>

<!-- *********************************************************************** -->
<!-- Template for UI -->
<!-- *********************************************************************** -->
<ng-template #loadingTournaments>
  <fz-skeleton viewBox="0 0 1360 900" height="900" width="1360">
    <svg:rect x="30" y="20" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="30" y="250" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="30" y="275" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="250" y="20" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="250" y="250" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="250" y="275" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="470" y="20" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="470" y="250" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="470" y="275" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="690" y="20" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="690" y="250" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="690" y="275" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="910" y="20" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="910" y="250" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="910" y="275" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="1130" y="20" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="1130" y="250" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="1130" y="275" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="30" y="340" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="30" y="570" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="30" y="595" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="250" y="340" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="250" y="570" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="250" y="595" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="470" y="340" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="470" y="570" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="470" y="595" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="690" y="340" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="690" y="570" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="690" y="595" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="910" y="340" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="910" y="570" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="910" y="595" rx="0" ry="0" width="120" height="20" />
    <svg:rect x="1130" y="340" rx="8" ry="8" width="200" height="200" />
    <svg:rect x="1130" y="570" rx="0" ry="0" width="200" height="18" />
    <svg:rect x="1130" y="595" rx="0" ry="0" width="120" height="20" />
  </fz-skeleton>
</ng-template>

<ng-template #loadingError>
  <div *ngIf="error$" class="utility-message error">
    <img
      src="/shared/svg/error.svg"
      height="330"
      width="330"
      alt="Error illustration"
    />
    <div class="message">
      <p class="title mat-headline-medium">Apologies for the inconvenience</p>
      <p class="">
        We are currently experiencing difficulties with our service providers.
        The App may not work as expected. We are working on a resolution. Please
        try again in a few minutes.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #tournamentsListEmpty>
  <div class="utility-message">
    <img
      src="/shared/svg/404.svg"
      height="330"
      width="330"
      alt="Not found illustration"
    />
    <div class="message">
      <p class="title mat-headline-medium">Oops!</p>
      <p class="">
        No tournament available at this moment. Please check again later.
      </p>
    </div>
  </div>
</ng-template>
